import {
    customerTicketStore,
    resetCustomerTicketStore,
    setCustomerAddressModeSale,
} from "./customerTicket";
import { diversStore, resetDiversStore } from "./divers";
import { generalStore, resetGeneralStore } from "./general";
import {
    kitchenTicketStore,
    resetKitchenTicketStore,
    setKitchenCustomerAddressModeSale,
} from "./kitchenTicket";
import { modeleTicketStore, resetModeleTicketStore } from "./modeleTicket";
import {
    orchestratorStore,
    resetOrchestratorStore,
    setDataDivers,
    setDataThreedTicket,
} from "./orchestrator";

export * from "./general";
export * from "./customerTicket";
export * from "./kitchenTicket";
export * from "./modeleTicket";
export * from "./divers";
export * from "./orchestrator";

export function resetAllPrinterSettingStores(): void {
    resetGeneralStore();
    resetCustomerTicketStore();
    resetKitchenTicketStore();
    resetModeleTicketStore();
    resetDiversStore();
    resetOrchestratorStore();
}

export { generalStore as StoreGeneral };
export { customerTicketStore as storeCustomerTicket };
export { kitchenTicketStore as storeKitchenTicketType };
export { diversStore as storeDivers };
export { modeleTicketStore as storeModelTicket };
export { orchestratorStore as printerSettingOrchestratorStore };

export { setDataDivers as setDivers };
export { setDataThreedTicket as setDatathreedTicket };

export const setKitchenCustomerAddressModeSaleAsLegacy = setKitchenCustomerAddressModeSale;
export const setCustomerAddressModeSaleAsLegacy = setCustomerAddressModeSale;
